<template>
  <v-stepper v-model="step" class="password-stepper">
    <v-stepper-header>
      <v-stepper-step :complete="step > 1" step="1" color="greenMain">
        General info
      </v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step :complete="step > 2" step="2" color="greenMain">
        Address Info
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="step === 3" step="3" color="greenMain">
        Email & Password
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card class="deposit-form create-account-form" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>First Name*</legend>
                <v-text-field v-model="fname" label="Write First Name Here" single-line solo hide-details
                  class="custom-select"></v-text-field>
                <span v-if="!fname && error.fnameError" class="error-message" style="color: red; font-size: 12px">
                  {{ error.fnameError }}
                </span>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>
                  <i class="fa fa-lastfm-square" aria-hidden="true"></i> Last
                  Name*
                </legend>
                <v-text-field v-model="lname" label="Write Last Name Here" single-line solo hide-details
                  class="custom-select"></v-text-field>
                <span v-if="!lname && error.lnameError" class="error-message" style="color: red; font-size: 12px">
                  {{ error.lnameError }}
                </span>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>
                  <i class="fa fa-lastfm-square" aria-hidden="true"></i> Phone
                  Number
                </legend>
                <vue-tel-input v-model="mobile" :inputOptions="inputOptions"
                  :dropdownOptions="dropdownOptions"></vue-tel-input>
                <span v-if="mobile && error.mobileError" class="error-message" style="color: red; font-size: 12px">
                  {{ error.mobileError }}
                </span>
              </fieldset>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>
                  <i class="fa fa-lastfm-square" aria-hidden="true"></i>Date Of
                  Birth
                </legend>
                <v-dialog ref="dialog" v-model="modal" width="290px" class="">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dob" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down" readonly
                      v-bind="attrs" v-on="on" solo class="custom-datePicker custom-select"
                      placeholder="Select your birth date"></v-text-field>
                  </template>
                  <v-date-picker v-model="dob" class="custom-date-picker" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="modal = false">
                      Cancel
                    </v-btn>
                    <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="$refs.dialog.save(dob)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Referred By ( IB Code )</legend>
                <v-text-field label="Your Introducing Broker's Code " v-model="referred_by" single-line solo
                  hide-details type="number" class="custom-select"></v-text-field>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0" :disabled="$canRoute('create-new-user-account') !== 1" @click="updateStep(2)">
                Next Step
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-card class="deposit-form create-account-form" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Country</legend>
                <v-select solo :value="country" @input="onCountryChange" :items="countries" item-text="name"
                  item-value="id" append-icon="mdi-chevron-down" label="Click to select" class="custom-select"
                  hide-details></v-select>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <fieldset>
                <legend>State</legend>
                <v-select solo :value="state" @input="onStateChange" :items="states" item-text="name" item-value="id"
                  append-icon="mdi-chevron-down" label="Click to select" class="custom-select" hide-details></v-select>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <fieldset>
                <legend>City</legend>
                <v-select solo :value="city" @input="onCityChange" :items="cities" item-text="name" item-value="id"
                  append-icon="mdi-chevron-down" label="Click to select" class="custom-select" hide-details></v-select>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Zip Code</legend>
                <v-text-field label="Write Zip Code Here" v-model="postal_code" single-line solo hide-details
                  class="custom-select" type="number"></v-text-field>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <fieldset>
                <legend>Address</legend>
                <v-text-field label="Write Detail Here" v-model="address" single-line solo hide-details
                  class="custom-select"></v-text-field>
                <!-- <span v-if="!address && error.addressError" class="error-message" style="color: red; font-size: 12px">
                  {{ error.addressError }}
                </span> -->
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="6">
            <fieldset>
                <legend>Identity Verification</legend>
                <v-file-input v-model="identityDoc" label="Upload Doc Here" single-line solo hide-details class="custom-select" :rules="fileRules" prepend-icon="" @change="handleIdentityFileUpload"></v-file-input>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <fieldset>
                <legend>Residence Verification</legend>
                <v-file-input v-model="residenceDoc" label="Upload Doc Here" single-line solo hide-details class="custom-select" :rules="fileRules" prepend-icon="" @change="handleResidenceFileUpload"></v-file-input>
              </fieldset>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0" :disabled="$canRoute('create-new-user-account') !== 1" @click="updateStep(1)"
                style="margin-right: 4px">
                Previous Step
              </v-btn>
              <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0" :disabled="$canRoute('create-new-user-account') !== 1" @click="updateStep(3)">
                Next Step
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="3">
        <v-card class="deposit-form password-field create-account-form"
          :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
          <v-row>
            <v-col>
              <fieldset>
                <legend>Email*</legend>
                <v-text-field label="Write Email Here" v-model="email" single-line solo hide-details type="email"
                  class="custom-select"></v-text-field>
                <span v-if="!email && error.emailError" class="error-message" style="color: red; font-size: 12px">
                  {{ error.emailError }}
                </span>
              </fieldset>
              <fieldset>
                <legend>Password*</legend>
                <v-text-field label="Write New Password" v-model="password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" counter
                  @click:append="show1 = !show1" single-line solo hide-details class="custom-select"></v-text-field>
                <span v-if="!password && error.passwordError" class="error-message" style="color: red; font-size: 12px">
                  {{ error.passwordError }}
                </span>
              </fieldset>
              <fieldset>
                <legend>Confirm Password*</legend>
                <v-text-field v-model="password2" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show2 ? 'text' : 'password'" counter @click:append="show2 = !show2"
                  label="Write New Password Again" single-line solo hide-details class="custom-select"></v-text-field>
                <span v-if="!password2 && error.password2Error" class="error-message"
                  style="color: red; font-size: 12px">
                  {{ error.password2Error }}
                </span>
              </fieldset>
              <v-card-actions class="pa-0">
                <v-btn class="text-capitalize btn-account btn-account-last" color="greenMain" tile elevation="0" :disabled="$canRoute('create-new-user-account') !== 1" @click="updateStep(2)"
                  style="margin-right: 4px">
                  Previous Step
                </v-btn>
                <v-btn class="text-capitalize btn-account btn-account-last" color="greenMain" tile width="146px" elevation="0"
                  @click="createUser"
                  :loading="loading"
                  :disabled="loading || $canRoute('create-new-user-account') !== 1">
                  Create Account
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { mapState, mapActions } from "vuex";

import {
  COUNTRIES__ACTIONS,
  CITIES__ACTIONS,
  STATES__ACTIONS,
  NEWUSER__ACTIONS
} from "@/store/action-types";
import { isValidEmail } from "@/_helpers/validate";
import toast from "@/services/Notification";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

export default {
  components: {
    VueTelInput,
  },
  data() {
    return {
      show1: false,
      show2: false,
      fname: "",
      lname: "",
      dob: "",
      referred_by: "",
      postal_code: "",
      address: "",
      identityDoc: null,
      residenceDoc: null,
      previewUrl: null,
      loading: false,
      email: "",
      country: "",
      city: "",
      state: "",
      password: "",
      password2: "",
      modal: false,
      dialog: false,
      mobile: "",
      fileRules: [
        (value) =>
          !value || value.size < 2000000 || "File size should be less than 2MB",
      ],
      inputOptions: {
        showDialCode: true,
        autocomplete: false,
      },
      dropdownOptions: {
        showSearchBox: true,
        showFlags: true,
      },
      error: {
        fnameError: "",
        lnameError: "",
        addressError: "",
        emailError: "",
        passwordError: "",
        password2Error: "",
        mobileError: "",
        fileErrorMessage: ""
      },
    };
  },
  computed: {
    ...mapState("countries", ["countries"]),
    ...mapState("cities", ["cities"]),
    ...mapState("states", ["states"]),
    ...mapState("__modal", ["open"]),
    ...mapState("newUser", ["step", "isUserCreated"]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    ...mapActions("countries", [COUNTRIES__ACTIONS.COUNTRIES]),
    ...mapActions("cities", [CITIES__ACTIONS.CITIES]),
    ...mapActions("states", [STATES__ACTIONS.STATES]),
    ...mapActions("newUser", [NEWUSER__ACTIONS.NEWUSER]),

    onCountryChange(value) {
      this[STATES__ACTIONS.STATES](value);
      this.country = value;
    },

    onStateChange(value) {
      this[CITIES__ACTIONS.CITIES](value);
      this.state = value;
    },

    onCityChange(value) {
      this.city = value;
    },

    updateStep(step) {
      if (step === 2) {
        if (this.fname === null || this.fname.trim() === "") {
          this.error.fnameError = "First name field is required";
        } else {
          this.error.fnameError = null; // Clear fname error if it's filled
        }

        if (this.lname === null || this.lname.trim() === "") {
          this.error.lnameError = "Last Name field is required";
        } else {
          this.error.lnameError = null; // Clear lname error if it's filled
        }

        const phoneNumberRegex = /^\+?\d+(\s\d+)*$/;

        if (this.mobile && !phoneNumberRegex.test(this.mobile)) {
          this.error.mobileError = "Phone number must contain only numbers";
        } else {
          this.error.mobileError = null;
        }

        if (
          !this.error.fnameError &&
          !this.error.lnameError &&
          !this.error.mobileError
        ) {
          this.$store.commit("newUser/SET_STEP", step);
        }
      }
      //  else if (step === 3) {
      //   if (this.address === null || this.address.trim() === "") {
      //     this.error.addressError = "Address field is required";
      //   } else {
      //     this.error.addressError = null; // Clear address error if it's filled
      //   }

      //   // Proceed if address is filled
      //   if (!this.error.addressError) {
      //     this.$store.commit("newUser/SET_STEP", step);
      //   }
      // } 
      else {
        this.$store.commit("newUser/SET_STEP", step);
      }
    },

    async handleIdentityFileUpload(file) {
      if (file && file.size < 4000000) {
        this.identityDoc = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.identityDoc = null;
        this.previewUrl = null;
        this.fileError = true;
        this.error.fileErrorMessage = "File size should be less than 4MB";
      }
    },

    async handleResidenceFileUpload(file) {
      if (file && file.size < 4000000) {
        this.residenceDoc = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.residenceDoc = null;
        this.previewUrl = null;
        this.fileError = true;
        this.error.fileErrorMessage = "File size should be less than 4MB";
      }
    },

    async createUser() {
      this.loading = true;

      try {
        if (!isValidEmail(this.email)) {
          this.error.emailError = "Email format is invalid";
        } else {
          this.error.emailError = null;
        }
  
        if (this.email === null || this.email.trim() === "") {
          this.error.emailError = "Email field is required";
        } else {
          this.error.emailError = null;
        }
  
        if (this.password === null || this.password.trim() === "") {
          this.error.passwordError = "Password field is required";
        } else {
          this.error.passwordError = null;
        }
  
        if (this.password.trim() !== this.password2.trim()) {
          this.error.password2Error = "Password mismatch";
        } else {
          this.error.password2Error = null;
        }
  
        const parameters = {
          fname: this.fname,
          lname: this.lname,
          dob: this.dob,
          referred_by: this.referred_by,
          country_id: this.country,
          city_id: this.city,
          state_id: this.state,
          postal_code: this.postal_code,
          address: this.address,
          identityDoc: this.identityDoc,
          residenceDoc: this.residenceDoc,
          email: this.email,
          password: this.password,
          mobile: this.mobile.length < 4 ? null : this.mobile,
        };
  
        await this[NEWUSER__ACTIONS.NEWUSER](parameters);

      } 
      catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
        if (this.isUserCreated === true) {
          this.fname = "";
          this.lname = "";
          this.dob = "";
          this.referred_by = "";
          this.country = "";
          this.city = "";
          this.state = "";
          this.postal_code = "";
          this.address = "";
          identityDoc=null,
          residenceDoc=null,
          this.email = "";
          this.password = "";
          this.password2 = "";
          this.mobile = "";
        }
      }
    },
  },

  async created() {
    await this[COUNTRIES__ACTIONS.COUNTRIES]();
  },
};
</script>

<style scoped lang="css">
  .btn-account-last {
    width: max-content !important;
    display: flex;
    justify-content: center;
  }
  </style>